/*
 * @Author: 文雄 wuzhao@fumihr.com
 * @Date: 2022-06-27 11:14:19
 * @LastEditors: 文雄 wenxiong@fumihr.com
 * @LastEditTime: 2023-05-31 15:00:00
 * @FilePath: src\plugins\vant.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue';
import 'vant/lib/index.css';
import {
	Button,
	Toast,
	Dialog,
	Form,
	Cell,
	Field,
	Empty,
	Image,
	Search,
	Steps,
	Step,
	Loading,
	NoticeBar,
	NavBar,
	Popup,
	Radio,
	RadioGroup,
	DropdownMenu,
	DropdownItem,
	Divider,
	Pagination
} from 'vant';
Vue.use(Button);
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(Form);
Vue.use(Cell);
Vue.use(Field);
Vue.use(Empty);
Vue.use(Image);
Vue.use(Search);
Vue.use(Steps);
Vue.use(Step);
Vue.use(Loading);
Vue.use(NoticeBar);
Vue.use(NavBar);
Vue.use(Popup);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Divider);
Vue.use(Pagination);

